module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-container"
  }, [_c('a', {
    staticClass: "signup-link",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.signup($event)
      }
    }
  }, [_vm._v("You don't have an account?")]), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("Daily UI")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("Welcome back!")]), _vm._v(" "), _c('form', {
    staticClass: "login-form"
  }, [_c('div', {
    staticClass: "form-input"
  }, [_c('i', {
    staticClass: "fa fa-envelope",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "focus",
      rawName: "v-focus",
      value: (_vm.focused),
      expression: "focused"
    }],
    staticClass: "email",
    attrs: {
      "type": "email",
      "placeholder": "E-mail Address"
    },
    on: {
      "focus": function($event) {
        _vm.focused = true
      },
      "blur": function($event) {
        _vm.focused = false
      }
    }
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "login-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
      }
    }
  }, [_vm._v("SIGN IN")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-input"
  }, [_c('i', {
    staticClass: "fa fa-lock",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "password",
    attrs: {
      "type": "password",
      "placeholder": "Password"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5224a42a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 20
// module chunks = 0